import { VerifyingLoader } from './VerifyingLoader';

export default VerifyingLoader;
